export default __webpack_public_path__ + "static/media/magna-logo.81d1c9a9.png";